import { useEffect, useState } from "react";
import { CurrentsAPI, type OceanOrgGuardrail } from "@vida/currents-core";
import { createCurrentsApiConfig } from "../services/currentsSession";

export function GuardrailsCatalogPage() {
  const [items, setItems] = useState<OceanOrgGuardrail[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    void (async () => {
      try {
        const guardrails = await CurrentsAPI.listOrgGuardrails(
          createCurrentsApiConfig(),
          undefined,
          false,
        );
        setItems(guardrails);
      } catch (e) {
        setError(e instanceof Error ? e.message : String(e));
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <div className="page">
      <header className="page-header">
        <div>
          <h1>Guardrails</h1>
          <p className="muted">Regole di comportamento condivise tra gli agenti dell&apos;organizzazione.</p>
        </div>
      </header>

      {loading && <p className="muted">Caricamento…</p>}
      {error && <p className="err">{error}</p>}

      {!loading && !error && items.length === 0 && (
        <div className="card">
          <p className="muted">Nessun guardrail nel catalogo.</p>
        </div>
      )}

      {!loading && !error && items.length > 0 && (
        <div className="catalog-grid">
          {items.map((g) => (
            <article key={g.id} className="catalog-card">
              <div className="catalog-card-head">
                <span className="catalog-icon" aria-hidden>
                  🛡️
                </span>
                <div>
                  <h2>{g.name}</h2>
                  <code className="catalog-id">{g.id}</code>
                </div>
              </div>
              {g.description && <p className="muted">{g.description}</p>}
              <p className="catalog-rule">{g.ruleText}</p>
              <p className="catalog-meta">
                <span className="chip">{g.enabled ? "Attivo" : "Disabilitato"}</span>
              </p>
            </article>
          ))}
        </div>
      )}
    </div>
  );
}
